export const socialsList = [
  {
    name: "Github",
    link: "https://github.com/mwaqarshahid",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/waqarshahid/",
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/M.Waqar.Shahid/",
  },
  {
    name: "Twitter",
    link: "https://twitter.com/m_waqar_shahid",
  },
  {
    name: "Xing",
    link: "https://www.xing.com/profile/MuhammadWaqar_Shahid/cv",
  },
];
